import { get } from 'svelte/store';
import { SoundPlayerState } from './sound-types';
export class SoundPlayerStateAwareSoundPlayer {
    constructor(soundPlayerState, target) {
        this.soundPlayerState = soundPlayerState;
        this.target = target;
        this.playNewConversationNotificationAfterPreload = false;
    }
    async preload() {
        await this.target.preload();
        if (this.playNewConversationNotificationAfterPreload) {
            await this.playNewConversationNotificationLoop();
        }
    }
    async playNewMessageNotification() {
        if (get(this.soundPlayerState) === SoundPlayerState.PRELOADED) {
            return await this.target.playNewMessageNotification();
        }
    }
    muteNewMessageNotification() {
        this.target.muteNewMessageNotification();
    }
    unmuteNewMessageNotification() {
        this.target.unmuteNewMessageNotification();
    }
    async playNewConversationNotificationLoop() {
        if (get(this.soundPlayerState) === SoundPlayerState.PRELOADED) {
            return await this.target.playNewConversationNotificationLoop();
        }
        else {
            this.playNewConversationNotificationAfterPreload = true;
        }
    }
    muteNewConversationNotificationLoop() {
        this.target.muteNewConversationNotificationLoop();
    }
    unmuteNewConversationNotificationLoop() {
        this.target.unmuteNewConversationNotificationLoop();
    }
    async stopNewConversationNotificationLoop() {
        if (get(this.soundPlayerState) === SoundPlayerState.PRELOADED) {
            return await this.target.stopNewConversationNotificationLoop();
        }
        else {
            this.playNewConversationNotificationAfterPreload = false;
        }
    }
}
